module.exports = __webpack_public_path__ + "img/thumb-up.c647e91.svg";